export const favorites = (page = 1, pageSize = 32): string =>
  `/favorites?page=${page}&page_size=${pageSize}`;

export const favoriteStrain = (strainId: string): string =>
  `/strains/${strainId}/favorite`;
